var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5107 15.455H18.9057L26.9007 0H20.5057L12.5107 15.455Z",
    fill: "#006CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.508 7.72754L13.3105 13.91L14.1105 15.455H18.9055L19.7055 13.91L16.508 7.72754Z",
    fill: "#101010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4188 19.1877H13.0238V15.4552H19.4188V19.1877ZM19.4188 13.8577H13.0238C12.5995 13.8577 12.1925 14.0262 11.8925 14.3263C11.5924 14.6264 11.4238 15.0333 11.4238 15.4577V19.1877C11.4238 19.612 11.5924 20.019 11.8925 20.319C12.1925 20.6191 12.5995 20.7877 13.0238 20.7877H19.4188C20.3013 20.7877 21.0163 20.0727 21.0163 19.1877V15.4552C21.0163 14.5727 20.3013 13.8577 19.4188 13.8577Z",
    fill: "#FCC21B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2136 23.9825C24.2136 28.3975 20.6336 31.9775 16.2186 31.9775C11.8036 31.9775 8.22363 28.4 8.22363 23.9825C8.22363 19.565 11.8036 15.9875 16.2186 15.9875C20.6361 15.9875 24.2136 19.5675 24.2136 23.9825Z",
    fill: "#FCC21B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8601 22.0375C10.7551 22.0375 10.6501 22.0175 10.5501 21.9725C10.1651 21.8075 9.98013 21.36 10.1301 20.9725C10.1326 20.9675 10.1351 20.96 10.1351 20.955C10.1376 20.9425 10.1401 20.945 10.1451 20.935C10.8526 19.25 12.3351 18.005 14.1151 17.5925C14.2026 17.5725 14.2951 17.615 14.3351 17.6975C14.3751 17.78 14.3526 17.88 14.2801 17.9375C13.1126 18.865 12.1801 20.115 11.5851 21.555C11.5851 21.5575 11.5826 21.56 11.5826 21.56C11.5826 21.56 11.5826 21.5625 11.5801 21.5625C11.4976 21.755 11.3451 21.905 11.1501 21.98C11.0576 22.02 10.9576 22.0375 10.8601 22.0375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4408 15.455H13.0433L5.05078 0H11.4458L19.4408 15.455Z",
    fill: "#006CA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenBadge);
export default __webpack_public_path__ + "static/media/golden-badge.42c8d9a5ad4015d06a490d3e39517f9e.svg";
export { ForwardRef as ReactComponent };